var _excluded = ["children", "marginFix", "spacing", "container"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import MuiGrid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
function Grid(_ref) {
  var children = _ref.children,
    marginFix = _ref.marginFix,
    spacing = _ref.spacing,
    container = _ref.container,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var theme = useTheme();
  return marginFix && spacing && container ? /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "" + theme.spacing(spacing)
    }
  }, /*#__PURE__*/React.createElement(MuiGrid, _extends({
    container: true,
    spacing: spacing
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, rest), children)) : /*#__PURE__*/React.createElement(MuiGrid, _extends({
    spacing: spacing,
    container: container
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, rest), children);
}
Grid.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * React component, HTML node, string etc..
   */
  children: PropTypes.node.isRequired,
  spacing: PropTypes.number,
  container: PropTypes.bool,
  /**
   * Remove negative margin issues on containers
   * @see https://material-ui.com/components/grid/#negative-margin
   */
  marginFix: PropTypes.bool
} : {};
Grid.defaultProps = {
  spacing: undefined,
  container: undefined,
  marginFix: false
};
export default Grid;